import { QuoteRatingSearchRequestQuery } from '@lio/api-types';
import { quoteRatingStatus } from '@models/quoteRating';

export const getSearchQuoteRatingsUrl = (params: QuoteRatingSearchRequestQuery) => {
  const { status, sort, pageLimit, pageOffset, hasRateChangeAnalysis } = params;
  const query = new URLSearchParams();
  if (status) {
    query.append('status', status);
  }
  if (sort) {
    query.append('sort', String(sort));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (typeof hasRateChangeAnalysis === 'boolean') {
    query.append('hasRateChangeAnalysis', String(hasRateChangeAnalysis));
  } else {
    // default behavior is to filter out ratings with rate change analysis to preserve existing functionality
    query.append('hasRateChangeAnalysis', 'false');
  }
  return query;
};

export const searchLastSuccessfulRatingParams = {
  status: quoteRatingStatus.Succeeded,
  sort: '-completedAt',
  pageLimit: 1,
};
